<template>
  <div class="footer">
    <!-- <footer>©Walking Technology. All Rights Reserved.</footer> -->
    <!-- <footer>https://www.hunt-love.com/ belongs to PROMETHEUS HIGH TECHNOLOGY PTE. LTD.</footer> -->
     <div class="wrap">
        <div class="left">
          <a href="/terms">Terms and Conditions</a>
          <a href="/privacypolicy">Privacy & Policy</a>
        </div>
        <div class="right">Copyright ©by Walking Technology.</div>
     </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      logo_name: "",
    };
  },
  created() {
    this.renderUI();
  },
  methods: {
    renderUI() {
      const config = this.$store.state.data;
      this.logo_name = config.logo_name;
    },
  },
};
</script>

<style lang="less" scoped>
.footer {
  // position: fixed;
  // height: 93px;
  // bottom: 0px;
  width: 100%;
  height: 80px;
  line-height: 80px;
  font-family: 'Poppins',sans-serif;
  // background: #ffffff;
  // text-align: center;
  font-size: 15px;
  color: #fff;
  // font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  // color: #797979;
  // line-height: 93px;
  // letter-spacing: 1px;
  background-color: #391092;
  .wrap{
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 1100px;
    margin: 0 auto;
  }
  a{
    color: #fff;
    text-decoration: none;
    margin-right: 30px;
    transition: all 500ms ease;
    &:hover{
      color: #ff8a42;
    }
  }
}
</style>